/**
 * Auth contract additions for Clerk sign-in (ADR-0021; F10 AUTH-152, AUTH-164).
 * Re-exported from index.ts. Owner: auth (F10).
 */

export const AUTH_ROUTES = {
  /** GET -> 200 AuthConfigResponse (E115; AUTH-152). Under /auth, not /api, so the landing page makes no extra API request. */
  authConfig: '/auth/config',
} as const;

/** GET authConfig. The publishable key is public by design; null when Clerk is not configured (AUTH-151). */
export interface AuthConfigResponse {
  clerkPublishableKey: string | null;
  /** True only when the Worker enables /auth/dev/start (DEV_LOGIN=true on http://localhost; AUTH-110). */
  devSignIn: boolean;
  /** BILL-130: pricing is paused, so the web app shows no prices, plans or trial (BILL-131). Here so signed-out pages know too. */
  pricingPaused: boolean;
}

/** The exact confirmation DELETE me requires (E57; AUTH-164). */
export const DELETE_ACCOUNT_CONFIRMATION = 'delete my account';

/** DELETE me body (E57). */
export interface DeleteAccountRequest {
  confirm: typeof DELETE_ACCOUNT_CONFIRMATION;
}
